import React, { useState } from 'react';

const DiagnoseFees = () => {
  const [admissionNo, setAdmissionNo] = useState('ADM255899');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const diagnose = async () => {
    setLoading(true);
    setResult(null);

    try {
      const token = localStorage.getItem('token');
      
      // Get student data
      const studentRes = await fetch(`/students?admission_number=${admissionNo}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const students = await studentRes.json();
      const student = students[0];

      if (!student) {
        setResult({ error: 'Student not found!' });
        setLoading(false);
        return;
      }

      // Get other fees for this student's course and session
      const feesRes = await fetch(`/other-fees`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const allFees = await feesRes.json();

      const matchingFees = allFees.filter(fee => 
        fee.course_id === student.course_id && 
        fee.session_id === student.session_id &&
        fee.is_mandatory === true
      );

      setResult({
        student: {
          admission_number: student.admission_number,
          name: student.full_name,
          course_id: student.course_id,
          course_name: student.course_name,
          session: student.session,
          session_id: student.session_id
        },
        matchingFees: matchingFees,
        totalFeesInSystem: allFees.length,
        diagnosis: matchingFees.length === 0 ? 'NO_FEES_MATCH' : 'FEES_FOUND'
      });
      setLoading(false);

    } catch (err) {
      setResult({ error: err.message });
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '900px', margin: '50px auto', padding: '30px' }}>
      <h1>🔍 Diagnose Other Fees Issue</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <label><strong>Admission Number:</strong></label><br/>
        <input 
          type="text" 
          value={admissionNo}
          onChange={(e) => setAdmissionNo(e.target.value)}
          style={{ padding: '10px', width: '300px', fontSize: '16px' }}
        />
        <button 
          onClick={diagnose}
          disabled={loading}
          style={{
            marginLeft: '10px',
            padding: '10px 20px',
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          {loading ? 'Checking...' : 'Diagnose'}
        </button>
      </div>

      {result && (
        <div style={{ marginTop: '30px' }}>
          {result.error && (
            <div style={{ padding: '20px', background: '#f8d7da', borderRadius: '5px', color: '#721c24' }}>
              <h3>❌ Error</h3>
              <p>{result.error}</p>
            </div>
          )}

          {result.student && (
            <>
              <div style={{ padding: '20px', background: '#d4edda', borderRadius: '5px', marginBottom: '20px' }}>
                <h3>✅ Student Found</h3>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr><td><strong>Admission No:</strong></td><td>{result.student.admission_number}</td></tr>
                    <tr><td><strong>Name:</strong></td><td>{result.student.name}</td></tr>
                    <tr><td><strong>Course:</strong></td><td>{result.student.course_name}</td></tr>
                    <tr><td><strong>Course ID:</strong></td><td style={{ fontSize: '12px', fontFamily: 'monospace' }}>{result.student.course_id}</td></tr>
                    <tr><td><strong>Session:</strong></td><td>{result.student.session}</td></tr>
                    <tr><td><strong>Session ID:</strong></td><td style={{ fontSize: '12px', fontFamily: 'monospace' }}>{result.student.session_id}</td></tr>
                  </tbody>
                </table>
              </div>

              {result.diagnosis === 'NO_FEES_MATCH' && (
                <div style={{ padding: '20px', background: '#fff3cd', borderRadius: '5px', marginBottom: '20px' }}>
                  <h3>⚠️ PROBLEM FOUND!</h3>
                  <p><strong>No mandatory fees are configured for:</strong></p>
                  <ul>
                    <li>Course: {result.student.course_name}</li>
                    <li>Session: {result.student.session}</li>
                  </ul>
                  <p><strong>Solution:</strong> Go to <strong>Master Settings → Other Fees</strong> and create mandatory fees for this course and session.</p>
                  <p>Total Other Fees in system: {result.totalFeesInSystem}</p>
                </div>
              )}

              {result.diagnosis === 'FEES_FOUND' && (
                <div style={{ padding: '20px', background: '#d4edda', borderRadius: '5px' }}>
                  <h3>✅ Mandatory Fees Found: {result.matchingFees.length}</h3>
                  {result.matchingFees.map((fee, idx) => (
                    <div key={idx} style={{ padding: '10px', background: 'white', margin: '10px 0', borderRadius: '5px' }}>
                      <strong>{fee.fee_name || 'Unnamed Fee'}</strong><br/>
                      Amount: ₹{fee.amount}<br/>
                      Fee ID: <span style={{ fontSize: '12px', fontFamily: 'monospace' }}>{fee.id}</span>
                    </div>
                  ))}
                  <p style={{ marginTop: '20px', color: '#155724' }}>
                    <strong>These fees SHOULD be showing in "Pay Other Fee" page!</strong><br/>
                    If they're not showing, there may be a frontend display issue.
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DiagnoseFees;
